'use client';

export default function Counter({ block }) {
  const splitData = block?.toLocaleString().split('');
  const numArr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

  return (
    <div className="donation-counter-wrapper visible flex w-full max-w-[800px] flex-row justify-center">
      {splitData.map((digit, index) => {
        return (
          <div key={index}>
            {digit == ',' ? (
              <div className="donation_counter--integer font-lustria block h-[80px] text-[80px] leading-[80px] lg:h-[128px] lg:text-[128px] lg:leading-[128px]">
                ,
              </div>
            ) : (
              <div
                className="donation_counter--integer_group nowrap h-[80px] flex-col overflow-hidden lg:h-[128px]"
                data-group={index + 1}
                data-number={digit}
              >
                {numArr.map((num, index) => {
                  return (
                    <span
                      key={index}
                      className={`donation_counter--integer font-lustria block h-[80px] text-[80px] leading-[80px] lg:h-[128px] lg:text-[128px] lg:leading-[128px]`}
                      data-integer={num}
                    >
                      {num}
                    </span>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
